import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchPublishedPosts } from "../../services/api";
import { resolveImageUrl } from "../../utils/driveImage";
import styles from "./RelatedPosts.module.css";

function formatDate(value) {
    if (!value) return "";
    const normalized = value.endsWith("Z") ? value : `${value.replace("+00:00", "")}Z`;
    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) return value;
    return new Intl.DateTimeFormat("pt-BR", { dateStyle: "medium" }).format(date);
}

export default function RelatedPosts({ currentSlug, category }) {
    const [posts, setPosts] = useState([]);

    useEffect(() => {
        if (!currentSlug) return;
        let cancelled = false;

        async function load() {
            try {
                const seen = new Set([currentSlug]);
                const collected = [];

                const pushUnique = (list) => {
                    for (const p of list || []) {
                        if (collected.length >= 3) break;
                        if (seen.has(p.slug)) continue;
                        seen.add(p.slug);
                        collected.push(p);
                    }
                };

                // 1) Prioriza posts da mesma categoria
                if (category) {
                    const sameCat = await fetchPublishedPosts({ category, per_page: 6 });
                    if (cancelled) return;
                    pushUnique(sameCat.posts);
                }

                // 2) Completa com os mais recentes quando faltam relacionados
                if (collected.length < 3) {
                    const recent = await fetchPublishedPosts({ per_page: 6 });
                    if (cancelled) return;
                    pushUnique(recent.posts);
                }

                setPosts(collected);
            } catch {
                // silently fail — artigos relacionados não são críticos
            }
        }

        load();

        return () => {
            cancelled = true;
        };
    }, [currentSlug, category]);

    if (posts.length === 0) return null;

    return (
        <section className={styles.section}>
            <h2 className={styles.sectionTitle}>Artigos relacionados</h2>
            <div className={styles.grid}>
                {posts.map((post) => {
                    const cover = resolveImageUrl(post.cover_image);
                    return (
                        <Link
                            key={post.id}
                            to={`/blog/${post.slug}`}
                            className={styles.card}
                        >
                            <div className={styles.cardCover}>
                                {cover ? (
                                    <img src={cover} alt={post.title} loading="lazy" />
                                ) : (
                                    <div className={styles.coverFallback}>
                                        <span>HL</span>
                                    </div>
                                )}
                            </div>
                            <div className={styles.cardBody}>
                                {post.category && (
                                    <span className={styles.category}>{post.category}</span>
                                )}
                                <h3 className={styles.cardTitle}>{post.title}</h3>
                                {post.published_at && (
                                    <time className={styles.cardDate}>
                                        {formatDate(post.published_at)}
                                    </time>
                                )}
                            </div>
                        </Link>
                    );
                })}
            </div>
        </section>
    );
}
